module.exports = __webpack_public_path__ + "img/um.6c46df56.png";